export const DOWNLOAD_APP_SECTION_ASSETS_BY_LANG = {
  en: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/en.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/en.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/en-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/en-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=en',
    APP_STORE_LINK:
      'https://apps.apple.com/en/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  es: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/es.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/es.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/es-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/es-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=es',
    APP_STORE_LINK:
      'https://apps.apple.com/es/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  fr: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/fr.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/fr.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/fr-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/fr-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=fr',
    APP_STORE_LINK:
      'https://apps.apple.com/fr/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  it: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/it.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/it.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/it-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/it-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=it',
    APP_STORE_LINK:
      'https://apps.apple.com/it/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  de: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/de.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/de.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/de-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/de-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=de',
    APP_STORE_LINK:
      'https://apps.apple.com/de/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  pt: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/pt.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/pt.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/pt-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/pt-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=pt',
    APP_STORE_LINK:
      'https://apps.apple.com/pt/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  nl: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/nl.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/nl.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/nl-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/nl-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=nl',
    APP_STORE_LINK:
      'https://apps.apple.com/nl/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  da: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/da.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/da.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/da-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/da-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=da',
    APP_STORE_LINK:
      'https://apps.apple.com/da/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  no: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/no.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/no.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/no-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/no-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=no',
    APP_STORE_LINK:
      'https://apps.apple.com/no/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  pl: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/pl.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/pl.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/pl-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/pl-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=pl',
    APP_STORE_LINK:
      'https://apps.apple.com/pl/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  ro: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/ro.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/ro.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/ro-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/ro-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=ro',
    APP_STORE_LINK:
      'https://apps.apple.com/ro/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  ru: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/ru.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/ru.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/ru-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/ru-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=ru',
    APP_STORE_LINK:
      'https://apps.apple.com/ru/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  sv: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/sv.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/sv.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/sv-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/sv-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=sv',
    APP_STORE_LINK:
      'https://apps.apple.com/sv/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
  tr: {
    PLAY_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/tr.png',
    APP_STORE_IMAGE_URL:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/tr.png',
    PLAY_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/play-store/tr-light.png',
    APP_STORE_IMAGE_URL_LIGHT:
      'https://cdn-imgix.headout.com/assets/images/badges/app-store/tr-light.png',
    PLAY_STORE_LINK:
      'https://play.google.com/store/apps/details?id=com.tourlandish.chronos&hl=tr',
    APP_STORE_LINK:
      'https://apps.apple.com/tr/app/headout-travel-experiences/id899327000?ls=1&mt=8',
  },
};
